import { Num } from '../utils';
export class Coordinates {
public x: number;
public y: number;
public px: number;
public py: number;
/**
 * @param {?} x
 * @param {?} y
 */
constructor(x: number, y: number) {
    if(Num.isNaN(x, y)) {
      throw Error('X and Y must be valid numbers');
    }
    this.x = x;
    this.y = y;
    this.px = this.x;
    this.py = this.y;
  }
/**
 * @param {?} y
 * @return {?}
 */
public setY(y: number): void {
    this.y = y;
  }
/**
 * @param {?} xSpeed
 * @param {?} ySpeed
 * @return {?}
 */
public move(xSpeed: number, ySpeed: number): void {
    this.px = this.x;
    this.py = this.y;
    this.x += xSpeed;
    this.y += ySpeed;
  }
/**
 * @return {?}
 */
public toPrevious(): void {
    this.x = this.px;
    this.y = this.py;
  }
}

function Coordinates_tsickle_Closure_declarations() {
/** @type {?} */
Coordinates.prototype.x;
/** @type {?} */
Coordinates.prototype.y;
/** @type {?} */
Coordinates.prototype.px;
/** @type {?} */
Coordinates.prototype.py;
}
